// URL aplikace na jednom místě. Adresy jsou tytéž, které renderuje Worker pro
// SEO (čeština na rootu, angličtina pod `/en/`), takže se tvar cesty nesmí
// rozejít s `worker/seo/i18n.ts`.
//
// Nový jazyk = přidat jeho prefix do `LOCALE_PREFIX` **a** do `parseLocale`
// ve `worker/seo/i18n.ts`. (Worker má prefix hardcodovaný stejně; sdílet kód
// mezi oběma TS projekty by tu bylo dražší než ten jeden řádek.)

import type { Locale } from "../i18n/locale";

/** Prefixované jazyky; `cs` sídlí na rootu, a tak v regexu není. */
const LOCALE_PREFIX = /^\/(en)(?=\/|$)/;

/**
 * Rozdělí cestu na jazyk z prefixu a zbytek bez prefixu.
 * `/en/wc/1` → `{ en, "/wc/1" }`, `/wc/1` → `{ null, "/wc/1" }`.
 * `locale: null` znamená „cesta jazyk neurčuje" (root patří češtině, ale
 * o výběru jazyka pak rozhoduje uložená volba / prohlížeč).
 */
export function parsePath(pathname: string): { locale: Locale | null; rest: string } {
  const m = pathname.match(LOCALE_PREFIX);
  if (!m) return { locale: null, rest: pathname };
  return { locale: m[1] as Locale, rest: pathname.slice(m[0].length) || "/" };
}

/** Lokalizovaná cesta: čeština na rootu, ostatní jazyky s prefixem (`/en/...`). */
export function localePath(locale: Locale, path: string): string {
  const prefix = locale === "cs" ? "" : `/${locale}`;
  if (!path || path === "/") return prefix || "/";
  return prefix + path;
}

/** Neprefixovaná cesta detailu WC. */
export function wcPath(id: number): string {
  return `/wc/${id}`;
}

/** ID WC z deep-linku `/wc/:id` (i `/en/wc/:id`), jinak null. */
export function restroomIdFromPath(pathname: string): number | null {
  const m = parsePath(pathname).rest.match(/^\/wc\/(\d+)$/);
  return m ? Number(m[1]) : null;
}
